import React, { useState, useRef, useEffect } from "react";
import { StyledHeader } from "./Styles";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import webappMenu from "./Styles/assets/Graphics/webapp-menu.webp";
import mobileApp from "./Styles/assets/Graphics/mobile-app.webp";
import seoMenu from "./Styles/assets/Graphics/seo-menu.webp";
import uiuxMenu from "./Styles/assets/Graphics/uiux-menu.webp";
import wordpressMenu from "./Styles/assets/Graphics/wordpress-menu.webp";
import socialMenu from "./Styles/assets/Graphics/social-menu.webp";
import dentalMenu from "./Styles/assets/Graphics/dental-menu.webp";
import daycareMenu from "./Styles/assets/Graphics/daycare-menu.webp";
import pricingMenu1 from "./Styles/assets/Graphics/pricing-menu1.webp";
import pricingMenu2 from "./Styles/assets/Graphics/pricing-menu2.webp";
import pricingMenu3 from "./Styles/assets/Graphics/pricing-menu3.webp";
import pricingMenu4 from "./Styles/assets/Graphics/pricing-menu4.webp";
import pricingMenu5 from "./Styles/assets/Graphics/pricing-menu5.webp";
import RestaurantMenu from "./Styles/assets/Graphics/RestaurantMenu.webp";
import fitnessMenu from "./Styles/assets/Graphics/fitness-menu.webp";
import { useTranslation } from "react-i18next";
import { slugs } from "../config/slugs";
import { StyledButton } from "../components/Styles";
import i18n from "i18next";

const Header = () => {
  const [isServicesOpen, setIsServicesOpen] = useState(false);
  const [isClientsOpen, setIsClientsOpen] = useState(false);
  const [isPricingOpen, setIsPricingOpen] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [iconChange, setIconChange] = useState(false);
  const navigate = useNavigate();
  const headerRef = useRef(null);
  const location = useLocation();
  const { t } = useTranslation();
  // const { lang } = useParams();


  const { i18n } = useTranslation();
  const lang = i18n.language;

  const toggleServices = () => {
    setIsClientsOpen(false);
    setIsPricingOpen(false);
    setIsServicesOpen((prev) => !prev);
  };

  const toggleClients = () => {
    setIsServicesOpen(false);
    setIsPricingOpen(false);
    setIsClientsOpen((prev) => !prev);
  };

  const togglePricing = () => {
    setIsServicesOpen(false);
    setIsClientsOpen(false);
    setIsPricingOpen((prev) => !prev);
  };

  const toggleMenu = () => {
    setIsMenuOpen((prev) => !prev);
    setIconChange((prev) => !prev);
  };

  const handleClickOutside = (event) => {
    if (headerRef.current && !headerRef.current.contains(event.target)) {
      setIsMenuOpen(false);
      setIsServicesOpen(false);
      setIsClientsOpen(false);
      setIsPricingOpen(false);
      setIconChange(false);
    }
  };

  const handleSubmenuItemClick = () => {
    setIsMenuOpen(false);
    setIconChange(false); // Reset icon to three-line after submenu navigation
  };


  const changeLanguage = (newLang) => {
    const pathParts = decodeURIComponent(location.pathname)
      .split("/")
      .filter(Boolean);

    const currentLang = pathParts[0];
    const currentSlug = pathParts[1];

    let targetPath = `/${newLang}`;

    if (currentSlug) {
      const routeKey = Object.keys(slugs).find(
        key => slugs[key][currentLang] === currentSlug
      );

      if (routeKey) {
        targetPath += `/${slugs[routeKey][newLang]}`;
      }
    }

    i18n.changeLanguage(newLang);
    navigate(targetPath);
  };


  useEffect(() => {
    // Reset icon and menu when location changes to ensure consistency
    setIsMenuOpen(false);
    setIconChange(false);
    setIsServicesOpen(false);
    setIsClientsOpen(false);
    setIsPricingOpen(false);
  }, [location]);

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <StyledHeader.HeaderContainer ref={headerRef}>
      <StyledHeader.Wrapper>

        <StyledHeader.Icon
          className={iconChange ? "change" : ""}
          onClick={toggleMenu}
        >
          <div className="bar1"></div>
          <div className="bar2"></div>
          <div className="bar3"></div>
        </StyledHeader.Icon>
        <StyledHeader.Logo lang={i18n.language}>
          <Link style={{ textDecoration: "None", color: "inherit" }} to={`/${lang}/`}>
            <StyledHeader.SubmenuImage src="/logo.png" alt="samandoon" />
            {t("header.samandoon")}
          </Link>
        </StyledHeader.Logo>
      </StyledHeader.Wrapper>
      <StyledHeader.Nav isopen={isMenuOpen}>
        {/* <StyledHeader.NavItem onClick={() => handleSubmenuItemClick()}>
          <StyledHeader.MenuLink to={`/${lang}/`}>
            <span>
              {t("header.home")}
            </span>
          </StyledHeader.MenuLink>
        </StyledHeader.NavItem> */}





        <StyledHeader.NavItem onClick={toggleServices} lang={i18n.language}>
          {t("header.services")}
          <StyledHeader.Submenu isopen={isServicesOpen} lang={i18n.language}>
            <StyledHeader.MenuLink to={`/${lang}/${slugs.webApplication[lang]}`}>
              <StyledHeader.SubmenuItem onClick={handleSubmenuItemClick} lang={i18n.language}>
                <StyledHeader.SubmenuImage
                  lang={i18n.language}
                  src={webappMenu}
                  alt="Web Application"
                />
                <span>
                  {t("header.service.webapp")}
                </span>
              </StyledHeader.SubmenuItem>
            </StyledHeader.MenuLink>

            <StyledHeader.MenuLink to={`/${lang}/${slugs.mobileApplication[lang]}`}>
              <StyledHeader.SubmenuItem onClick={handleSubmenuItemClick}>
                <StyledHeader.SubmenuImage
                  src={mobileApp}
                  alt="mobile Application"
                />
                <span>
                  {t("header.service.mobile")}
                </span>
              </StyledHeader.SubmenuItem>
            </StyledHeader.MenuLink>

            <StyledHeader.MenuLink to={`/${lang}/${slugs.uiux[lang]}`}>
              <StyledHeader.SubmenuItem onClick={handleSubmenuItemClick}>
                <StyledHeader.SubmenuImage src={uiuxMenu} alt="uiux" />
                <span>
                  {t("header.service.uiux")}
                </span>
              </StyledHeader.SubmenuItem>
            </StyledHeader.MenuLink>

            <StyledHeader.MenuLink to={`/${lang}/${slugs.wordpress[lang]}`}>
              <StyledHeader.SubmenuItem onClick={handleSubmenuItemClick}>
                <StyledHeader.SubmenuImage
                  src={wordpressMenu}
                  alt="Wordpress"
                />
                <span>
                  {t("header.service.wordpress")}
                </span>
              </StyledHeader.SubmenuItem>
            </StyledHeader.MenuLink>

            <StyledHeader.MenuLink to={`/${lang}/${slugs.seo[lang]}`}>
              <StyledHeader.SubmenuItem onClick={handleSubmenuItemClick}>
                <StyledHeader.SubmenuImage src={seoMenu} alt="SEO" />
                <span>
                  {t("header.service.seo")}
                </span>
              </StyledHeader.SubmenuItem>
            </StyledHeader.MenuLink>

            <StyledHeader.MenuLink to={`/${lang}/${slugs.social[lang]}`}>
              <StyledHeader.SubmenuItem onClick={handleSubmenuItemClick}>
                <StyledHeader.SubmenuImage src={socialMenu} alt="Social" />
                <span>
                  {t("header.service.social")}
                </span>
              </StyledHeader.SubmenuItem>
            </StyledHeader.MenuLink>
          </StyledHeader.Submenu>
        </StyledHeader.NavItem>

        <StyledHeader.NavItem onClick={togglePricing} lang={i18n.language}>
          {t("header.pricing")}
          <StyledHeader.Submenu isopen={isPricingOpen} lang={i18n.language}>
            <StyledHeader.MenuLink to={`/${lang}/${slugs.webAppPricing[lang]}`}>
              <StyledHeader.SubmenuItem onClick={handleSubmenuItemClick}>
                <StyledHeader.SubmenuImage src={pricingMenu1} alt="pricing1" />
                <span>
                  {t("header.price.webapppricing")}
                </span>
              </StyledHeader.SubmenuItem>
            </StyledHeader.MenuLink>

            <StyledHeader.MenuLink to={`/${lang}/${slugs.mobileAppPricing[lang]}`}>
              <StyledHeader.SubmenuItem onClick={handleSubmenuItemClick}>
                <StyledHeader.SubmenuImage src={pricingMenu2} alt="pricing2" />
                <span>
                  {t("header.price.mobapppricing")}
                </span>
              </StyledHeader.SubmenuItem>
            </StyledHeader.MenuLink>

            <StyledHeader.MenuLink to={`/${lang}/${slugs.wordpressPricing[lang]}`}>
              <StyledHeader.SubmenuItem onClick={handleSubmenuItemClick}>
                <StyledHeader.SubmenuImage src={pricingMenu3} alt="pricing3" />
                <span>
                  {t("header.price.wordpresspricing")}
                </span>
              </StyledHeader.SubmenuItem>
            </StyledHeader.MenuLink>

            <StyledHeader.MenuLink to={`/${lang}/${slugs.seoPricing[lang]}`}>
              <StyledHeader.SubmenuItem onClick={handleSubmenuItemClick}>
                <StyledHeader.SubmenuImage src={pricingMenu4} alt="pricing4" />
                <span>
                  {t("header.price.seopricing")}
                </span>
              </StyledHeader.SubmenuItem>
            </StyledHeader.MenuLink>

            <StyledHeader.MenuLink to={`/${lang}/${slugs.uiuxPricing[lang]}`}>
              <StyledHeader.SubmenuItem onClick={handleSubmenuItemClick}>
                <StyledHeader.SubmenuImage src={pricingMenu5} alt="pricing5" />
                <span>
                  {t("header.price.uiuxpricing")}
                </span>
              </StyledHeader.SubmenuItem>
            </StyledHeader.MenuLink>
          </StyledHeader.Submenu>
        </StyledHeader.NavItem>

        <StyledHeader.NavItem onClick={toggleClients} lang={i18n.language}>
          {t("header.clients")}
          <StyledHeader.Submenu isopen={isClientsOpen} lang={i18n.language}>
            <StyledHeader.MenuLink to={`/${lang}/${slugs.dental[lang]}`}>
              <StyledHeader.SubmenuItem onClick={handleSubmenuItemClick}>
                <StyledHeader.SubmenuImage src={dentalMenu} alt="dental" />
                <span>
                  {t("header.customers.dental")}
                </span>
              </StyledHeader.SubmenuItem>
            </StyledHeader.MenuLink>

            <StyledHeader.MenuLink to={`/${lang}/${slugs.daycare[lang]}`}>
              <StyledHeader.SubmenuItem onClick={handleSubmenuItemClick}>
                <StyledHeader.SubmenuImage src={daycareMenu} alt="daycare" />
                <span>
                  {t("header.customers.daycare")}
                </span>
              </StyledHeader.SubmenuItem>
            </StyledHeader.MenuLink>

            {/* <StyledHeader.SubmenuItem onClick={handleSubmenuItemClick}>
              <StyledHeader.MenuLink to={`/${lang}/${slugs.seoPricing[lang]}`}>
                <StyledHeader.SubmenuImage
                  src={spaMenu}
                  alt="Spas and Beauty Salons"
                />
                Spas and Beauty Salons
                </StyledHeader.MenuLink>
            </StyledHeader.SubmenuItem> */}

            <StyledHeader.MenuLink to={`/${lang}/${slugs.gymFitness[lang]}`}>
              <StyledHeader.SubmenuItem onClick={handleSubmenuItemClick}>
                <StyledHeader.SubmenuImage
                  src={fitnessMenu}
                  alt="Fitness Studios and Gyms"
                />
                <span>
                  {t("header.customers.fitness")}
                </span>
              </StyledHeader.SubmenuItem>
            </StyledHeader.MenuLink>

            {/* <StyledHeader.SubmenuItem onClick={handleSubmenuItemClick}>
              <StyledHeader.MenuLink to={`/${lang}/${slugs.seoPricing[lang]}`}>
                <StyledHeader.SubmenuImage
                  src={daycareMenu}
                  alt="Real Estate Agencies"
                />
                Real Estate Agencies
              </StyledHeader.MenuLink>
            </StyledHeader.SubmenuItem> */}

            <StyledHeader.MenuLink to={`/${lang}/${slugs.restaurantCafe[lang]}`}>
              <StyledHeader.SubmenuItem onClick={handleSubmenuItemClick}>
                <StyledHeader.SubmenuImage
                  src={RestaurantMenu}
                  alt="Resturant"
                />
                <span>
                  {t("header.customers.restaurant")}
                </span>
              </StyledHeader.SubmenuItem>
            </StyledHeader.MenuLink>
          </StyledHeader.Submenu>
        </StyledHeader.NavItem>

        <StyledHeader.NavItem onClick={() => handleSubmenuItemClick()} lang={i18n.language}>
          <StyledHeader.MenuLink to={`/${lang}/${slugs.about[lang]}`}>
            {/* <span> */}
            {t("header.about")}
            {/* </span> */}
          </StyledHeader.MenuLink>
        </StyledHeader.NavItem>

        <StyledHeader.NavItem onClick={() => handleSubmenuItemClick()} lang={i18n.language}>
          <StyledHeader.MenuLink to={`/${lang}/${slugs.portfolio[lang]}`}>
            {/* <span> */}
            {t("header.portfolio")}
            {/* </span> */}
          </StyledHeader.MenuLink>
        </StyledHeader.NavItem>

        <StyledHeader.NavItem onClick={() => handleSubmenuItemClick()} lang={i18n.language}>
          <StyledHeader.MenuLink to={`/${lang}/${slugs.contact[lang]}`}>
            {/* <span> */}
            {t("header.contact")}
            {/* </span> */}
          </StyledHeader.MenuLink>
        </StyledHeader.NavItem>

        <StyledHeader.NavItem onClick={() => handleSubmenuItemClick()} lang={i18n.language}>
          <StyledHeader.MenuLink to={`/${lang}/${slugs.signin[lang]}`}>
            {/* <span> */}
            {t("header.signin")}
            {/* </span> */}
          </StyledHeader.MenuLink>
        </StyledHeader.NavItem>

        <StyledHeader.NavItem lang={i18n.language}>
          <StyledButton.CardButton small
            onClick={() =>
              changeLanguage(i18n.language === "fa" ? "en" : "fa")
            }
          >
            {i18n.language === "fa" ? "EN" : "FA"}
          </StyledButton.CardButton>
        </StyledHeader.NavItem>
      </StyledHeader.Nav>
    </StyledHeader.HeaderContainer>
  );
};

export default Header;
